<template>

  <div class="elevation-2 search-box white" v-if="searching">

    <v-toolbar flat="flat">
      <v-toolbar-title class="search-title">Search</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon class="search-bt"
              title="Hide the search"
              @click="closeSearch">mdi-magnify-close</v-icon>
    </v-toolbar>

    <v-container fluid="fluid" grid-list-md="grid-list-md">

      <v-layout row="row" wrap="wrap">

        <!-- SPORT -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <SportSelector ref="sportSelector"
                         :currentSportIDs="searchParams.sportID"
                         @sportSelected="sportSelected"/>
        </v-flex>

        <!-- MATCH -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-4">
          <v-text-field class="field"
                        v-model="searchParams.matchID"
                        label="Match ID"
                        placeholder="Match ID"></v-text-field>
        </v-flex>

        <!-- START DATE -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <DateSelector ref="startDateSelector"
                        :currentDate="searchParams.startDate"
                        :label="'From'"
                        @dateSelected="startDateSelected"/>
        </v-flex>

        <!-- END DATE -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <DateSelector ref="endDateSelector"
                        :currentDate="searchParams.endDate"
                        :label="'To'"
                        @dateSelected="endDateSelected"/>
        </v-flex>

        <!-- CLUB 1 -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <NEWClubSelector ref="club1Selector"
                           :currentClubID="searchParams.clubID"
                           :sportID="searchParams.sportID"
                           :label="'Club 1'"
                           @clubSelected="club1Selected"/>
        </v-flex>

        <!-- CLUB 2 -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <NEWClubSelector ref="club2Selector"
                           :currentClubID="searchParams.otherClubID"
                           :sportID="searchParams.sportID"
                           :label="'Club 2'"
                           @clubSelected="club2Selected"/>
        </v-flex>

        <!-- USER -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <NEWUserSelector ref="userSelector"
                           :label="'User'"
                           :currentUserID="searchParams.authorID"
                           @userSelected="userSelected"/>
        </v-flex>

        <!-- TYPES -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <VideoTypesSelector ref="videoTypesSelector"
                              :currentTypes="searchParams.types"
                              @typesSelected="typesSelected"/>
        </v-flex>

        <!-- FREEMODE -->
        <v-flex d-flex="d-flex" sm6 md3 class="px-5">
          <v-switch v-model="searchParams.freemode"
                      label="Freemode"></v-switch>
        </v-flex>

        <!-- SUSPENDED -->
        <v-flex d-flex="d-flex" sm6 md3 class="px-5">
          <v-switch v-model="searchParams.suspended"
                      label="Suspended"></v-switch>
        </v-flex>

        <!-- SUSPENDED -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <v-checkbox v-model="searchParams.suspended"
                      label="Suspended"></v-checkbox>
        </v-flex>

        <!-- MATCH FEDE ID -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-4">
          <v-text-field class="field"
                        v-model="searchParams.matchFedeID"
                        label="Match fede ID"
                        placeholder="Match fede ID"></v-text-field>
        </v-flex>

        <!-- CLUB 1 FEDE ID -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-4">
          <v-text-field class="field"
                        v-model="searchParams.clubFedeID"
                        label="Club 1 fede ID"
                        placeholder="Club 1 fede ID"></v-text-field>
        </v-flex>

        <!-- CLUB 2 FEDE ID -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-4">
          <v-text-field class="field"
                        v-model="searchParams.otherClubFedeID"
                        label="Club 2 fede ID"
                        placeholder="Club 2 fede ID"></v-text-field>
        </v-flex>

      </v-layout>

      <v-layout row="row" wrap="wrap">
        <v-spacer></v-spacer>
        <v-btn class="search-action" :small="true" color="primary" flat="flat" @click.native="clearSearch">Clear</v-btn>
        <v-btn class="search-action" :small="true" color="primary" @click.native="search">Search</v-btn>
      </v-layout>

    </v-container>

  </div>

</template>

<script>

import SportSelector from '../common/SportSelector'
import DateSelector from '../common/DateSelector'
import NEWClubSelector from '../common/NEWClubSelector'
import NEWUserSelector from '../common/NEWUserSelector'
import VideoTypesSelector from '../VideoTypesSelector'

export default {
  name: 'Search',
  components: {
    SportSelector,
    DateSelector,
    NEWClubSelector,
    NEWUserSelector,
    VideoTypesSelector
  },
  props: ['searching'],
  data () {
    return {
      searchParams: {
        sportID: '',
        matchID: '',
        startDate: '',
        endDate: '',
        clubID: '',
        otherClubID: '',
        authorID: '',
        types: [],
        freemode: false,
        suspended: false,
        matchFedeID: '',
        clubFedeID: '',
        otherClubFedeID: ''
      }
    }
  },
  methods: {
    search () {
      if (!this.searchParams.sportID) {
        delete this.searchParams.sportID
      }
      if (!this.searchParams.matchID) {
        delete this.searchParams.matchID
      }
      if (!this.searchParams.startDate) {
        delete this.searchParams.startDate
      }
      if (!this.searchParams.endDate) {
        delete this.searchParams.endDate
      }
      if (!this.searchParams.clubID) {
        delete this.searchParams.clubID
      }
      if (!this.searchParams.otherClubID) {
        delete this.searchParams.otherClubID
      }
      if (!this.searchParams.authorID) {
        delete this.searchParams.authorID
      }
      if (this.searchParams.types.length === 0) {
        this.searchParams.types = ['summary', 'point', 'wow', 'fail']
      }
      if (!this.searchParams.matchFedeID) {
        delete this.searchParams.matchFedeID
      }
      if (!this.searchParams.clubFedeID) {
        delete this.searchParams.clubFedeID
      }
      if (!this.searchParams.otherClubFedeID) {
        delete this.searchParams.otherClubFedeID
      }
      if (!this.searchParams.suspended) {
        delete this.searchParams.suspended
      }

      this.$emit('search', this.searchParams)
    },

    clearSearch () {
      this.$refs.sportSelector.clear()
      this.$refs.startDateSelector.clear()
      this.$refs.endDateSelector.clear()
      this.$refs.club1Selector.clear()
      this.$refs.club2Selector.clear()
      this.$refs.userSelector.clear()
      this.$refs.videoTypesSelector.clear()

      this.searchParams = {
        sportID: '',
        matchID: '',
        startDate: '',
        endDate: '',
        clubID: '',
        otherClubID: '',
        authorID: '',
        types: [],
        freemode: false,
        suspended: false,
        matchFedeID: '',
        clubFedeID: '',
        otherClubFedeID: ''
      }
      this.$emit('clearSearch')
    },

    closeSearch () {
      this.$emit('closeSearch')
    },

    sportSelected (sportid) {
      this.searchParams.sportID = sportid
    },
    startDateSelected (date) {
      this.searchParams.startDate = date
    },
    endDateSelected (date) {
      this.searchParams.endDate = date
    },
    club1Selected (clubid) {
      this.searchParams.clubID = clubid
    },
    club2Selected (clubid) {
      this.searchParams.otherClubID = clubid
    },
    userSelected (userid) {
      this.searchParams.authorID = userid
    },
    typesSelected (types) {
      this.searchParams.types = types
    }
  }
}

</script>

<style lang="scss" scoped>

  .search-box {
    margin-bottom: 30px;
  }

  .search-title {
    font-size: 1rem;
    font-weight: 700;
  }

  .field {
    margin: 0 24px;
  }

</style>



// WEBPACK FOOTER //
// src/components/videos/Search.vue